import { useEffect, useState } from 'react';
import './HowItWorksBanner.css';
import { Modal } from './ui';
import { useDevice } from '../hooks';

export function HowItWorksBanner() {
   const [bannerVisible, setBannerVisible] = useState<boolean>(true);
   const [modalVisible, setModalVisible] = useState<boolean>(false);
   const { isMobile } = useDevice();

   // useEffect(() => {
   //    const bannerVisible = localStorage.getItem('howItWorksBannerVisible');
   //    if (bannerVisible === 'false') {
   //       setBannerVisible(false);
   //    } else {
   //       setBannerVisible(true);
   //    }
   // }, []);

   return bannerVisible ? (
      <div className="banner how-it-works flex flex-1 gap-3">
         <h2 className="banner-title">Learn How GolfN Works</h2>

         {!isMobile && (
            <img
               src="/assets/images/smartphone.png"
               className="banner-image"
            />
         )}
         <div className="banner-right-container">
            <div
               className="button-border"
               onClick={() => setModalVisible(true)}>
               <div className="button">
                  <div className="button-content">
                     <img
                        src="/assets/icons/triangle.svg"
                        width={16}
                     />
                     <span className="button-text">Watch</span>
                  </div>
               </div>
            </div>

            {/* <div
               className="cross"
               onClick={() => {
                  setBannerVisible(false);
                  localStorage.setItem('howItWorksBannerVisible', 'false');
               }}
            /> */}
         </div>

         <Modal
            className=""
            onClose={() => {
               setModalVisible(false);
            }}
            active={modalVisible}
            transparent
            darkBackground>
            <div className="modal-content">
               <iframe
                  width="99.6%"
                  height="99.9%"
                  src="https://player.vimeo.com/video/1052629888?autoplay=1"></iframe>
            </div>
         </Modal>

         {/* <Modal
            isOpen={modalVisible}
            className="modal-content"
            overlayClassName="modal-overlay"
            onRequestClose={() => {
               setModalVisible(false);
            }}>
            <iframe
               width="99.6%"
               height="99.9%"
               src="https://player.vimeo.com/video/1052629888?autoplay=1"></iframe>
         </Modal> */}
      </div>
   ) : null;
}
